import axios from 'axios';
import http from './http';

export const getLocal   = async (request) => (await http.post('/getCity', request)).data;
export const getEvents  = async (request) => (await http.post('/getEventsP', request)).data;
export const getMedia   = async (request) => (await http.post('/getMedia', request)).data;
export const saveComment= async (request) => (await http.post('/saveComment', request)).data;
export const getContext= async (request) => (await http.post('/getContent', request)).data;


/*
export const getContext = async (token, request) => {
	const url = 'https://xibb6u88vd.execute-api.us-west-2.amazonaws.com/dev/getContent';
	const response = await axios.post( url, request, {headers: {
		'Authorization' : `Bearer ${token}`,
		'Content-Type': 'application/json'
	}});
	
	return response.data;
}

export const getLocal = async (token, request) => {
	const url = 'https://xibb6u88vd.execute-api.us-west-2.amazonaws.com/dev/getCity';
	const response = await axios.post( url, request, {headers: {
		'Authorization' : `Bearer ${token}`,
		'Content-Type': 'application/json'
	}});
	
	return response.data;
}

export const getEvents = async (token, request) => {
	const url = 'https://xibb6u88vd.execute-api.us-west-2.amazonaws.com/dev/getEventsP';
	const response = await axios.post( url, request, {headers: {
		'Authorization' : `Bearer ${token}`,
		'Content-Type': 'application/json'
	}});
	
	return response.data;
}

export const getMedia = async (token, request) => {
	const url = 'https://xibb6u88vd.execute-api.us-west-2.amazonaws.com/dev/getMedia';
	const response = await axios.post( url, request, {headers: {
		'Authorization' : `Bearer ${token}`,
		'Content-Type': 'application/json'
	}});
	
	return response.data;
}

export const saveComment = async (token, request) => {
	const url = 'https://xibb6u88vd.execute-api.us-west-2.amazonaws.com/dev/saveComment';
	const response = await axios.post( url, request, {headers: {
		'Authorization' : `Bearer ${token}`,
		'Content-Type': 'application/json'
	}});
	
	return response.data;
}
	*/